import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { META_REDUCERS } from '@ngrx/store';
import { DebugService } from '~/shared/services/debug.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpLoggingInterceptor } from '~/interceptors/httpLoggingInterceptor';
import { loggingMetaReducerFactory } from '~/modules/metaReducers/logging.meta-reducer';

/*
 * For productive builds, this file is replaced with index.prod.ts (see angular.json config). This way, the functionality in here
 * (like HttpLoggingInterceptor, StoreDevtoolsModule etc.) will be removed from prod bundles during tree-shaking.
 * https://ngrx.io/guide/store-devtools/recipes/exclude
 */

export const buildSpecificImports = [StoreDevtoolsModule.instrument({ connectInZone: true })];

export const buildSpecificProviders = [
  {
    provide: META_REDUCERS,
    deps: [DebugService],
    useFactory: loggingMetaReducerFactory,
    multi: true
  },
  { provide: HTTP_INTERCEPTORS, useClass: HttpLoggingInterceptor, multi: true }
];
